export default "__VITE_ASSET__BFzc$TKk__"